import { render } from "./BranchFormSidebar.vue?vue&type=template&id=710e2775"
import script from "./BranchFormSidebar.vue?vue&type=script&lang=js"
export * from "./BranchFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__